module.exports = __webpack_public_path__ + "static/media/outcomes.e7ef95c2.svg";